import SoundUtils from './SoundUtils';

export default class MobileAudioFix {
  constructor(context) {
    this.context = context;

    this.source = this.context.createBufferSource();
    this.source.buffer = this.context.createBuffer(1, 1, 22050);
    this.source.connect(this.context.destination);

    this._startSource = this._startSource.bind(this);
  }

  init() {
    this._patchSourceMethods();
    window.addEventListener('touchstart', this._startSource);
  }

  isUnlocked() {
    const hasStarted = this.source.playbackState === this.source.PLAYING_STATE;
    const hasFinished = this.source.playbackState === this.source.FINISHED_STATE;

    return hasStarted || hasFinished;
  }

  _startSource() {
    this.source.start();

    setTimeout(() => {
      window.removeEventListener('touchstart', this._startSource);
    }, 60);
  }

  _patchSourceMethods() {
    this.source.start = SoundUtils.methodPatch.start(this.source);
  }
}
